import { throttle } from "lodash";

declare const jQuery: any;
const $ = jQuery;

export function initMatchHeight(): void
{
    const $els = $(`[data-match-height]`);
    if ($els.length < 2)
    {
        return;
    }
    const completedAttrs: string[] = [];
    $els.each(function () {
        const $el = $(this);
        const attr: string = $el.attr("data-match-height");
        if (!attr || completedAttrs.indexOf(attr) >= 0)
        {
            return;
        }
        completedAttrs.push(attr);
        makeHeightsMatch($(`[data-match-height="${attr}"]`));
    });
}

export function makeHeightsMatch($els): void
{
    if ($els.length < 2)
    {
        return;
    }
    const fix = () => {
        $els.css({ height: "" });
        let maxH: number = 0;
        $els.each(function () {
            const h: number = $(this).height();
            if (h > maxH)
            {
                maxH = h;
            }
        }).css({ height: maxH });
    };
    fix();
    $(window).on("load resize", throttle(fix, 70));
}
